
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/markets/offerings/[slug]",
      function () {
        return require("private-next-pages/markets/offerings/[slug].tsx");
      }
    ]);
  